/**
 * Represents a response containing a list of items of type T and a total count of items.
 */
export interface IListResponse<T> {
  data: T[];
  totalCount: number;
}
